//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import Button from "../Reusable/Button";
import NewComboboxInput from "../Reusable/NewComboboxInput";

const SyncContact = ({ setOpenSyncContactPopup }) => {
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    setError,
    handleSubmit,
    clearErrors,
  } = useForm<any>({});

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["sync-contact"],
  });
  const handleSyncContact = async (values: any, setError: any) => {
    const url = APIS.SYNC_CONTACT;
    const formData = {
      ...values,
      user_type: "staff",
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOpenSyncContactPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw`px-4`}>
      <form
        onSubmit={handleSubmit((data) => handleSyncContact(data, setError))}
      >
        <NewComboboxInput
          url={APIS.CONTACT_GROUP}
          props={{}}
          queryKey={"contact-group"}
          register={register("group_name", {
            required: "Group Name is required",
          })}
          errors={errors?.group_name}
          name={"group_name"}
          label={"Group"}
          setValue={setValue}
          placeholder={"Search Group"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <div className={tw`flex w-full justify-end`}>
          <div className={tw`w-24`}>
            <Button label="Submit" isPostLoading={isPostLoading} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default SyncContact;
